import { type ReactElement, useEffect } from 'react'
import type { UIMessage } from 'ai'
import { useRequiredParams } from '@util'
import { useChat } from '@front/model'
import { NotReady } from '@components'
import { Chat } from './Chat'
import { createFileRoute } from '@tanstack/react-router'

type Params = {
  sessionId: string
}

function ChatPage(): ReactElement {
  const { sessionId } = useRequiredParams<Params>()
  const { data, isLoading, error, refetch } = useChat(sessionId, false)

  useEffect(() => {
    if (!isNewSession(sessionId)) refetch()
  }, [sessionId, refetch])

  if (isNewSession(sessionId)) return <Chat />

  if (isLoading || error || !data) return <NotReady data={data} error={error} isLoading={isLoading} id='chat' />

  return <ChatPageMessagesLoaded key={sessionId} sessionId={sessionId} messages={data.uiMessages} />
}

const isNewSession = (sessionId: string): boolean => {
  return sessionId === 'new'
}

type Props = Params & {
  messages: object[]
}

const ChatPageMessagesLoaded = ({ messages, sessionId }: Props): ReactElement => {
  return <Chat existingMessages={messages as UIMessage[]} sessionId={sessionId} />
}

export const Route = createFileRoute('/chat/$sessionId/')({
  component: ChatPage,
})
